import { useEffect, useMemo, useState } from "react";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Button, Tooltip, Typography } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import noCampaignImage from "../Images/ImageToStl.com_attached+files-rafiki+1.avif";
import axios from "axios";
import BaseUrl from "../BaseUrl";
import Modal from "@mui/material/Modal";
import Loader from "../Loader";
import { useHistory } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Switch from "@mui/material/Switch";
import Radio from "@mui/material/Radio";
import ListItemIcon from "@mui/material/ListItemIcon";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import PlayCircleFilledWhiteOutlinedIcon from "@mui/icons-material/PlayCircleFilledWhiteOutlined";
import PauseCircleOutlineOutlinedIcon from "@mui/icons-material/PauseCircleOutlineOutlined";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import BookOutlinedIcon from "@mui/icons-material/BookOutlined";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ModeEditRoundedIcon from "@mui/icons-material/ModeEditRounded";
import PlayCircleOutlineRoundedIcon from "@mui/icons-material/PlayCircleOutlineRounded";
import CircularProgress from "@mui/material/CircularProgress";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  CampaignClickedSvgIcon,
  CampaignOpenedSvgIcon,
  CampaignRepliedSvgIcon,
  CampaignSentSvgIcon,
} from "../CommonSvgs";

const headCells = [
  {
    id: "name",
    label: "Campaign name",
  },
  {
    id: "calories",
    label: "Sent",
  },
  {
    id: "fat",
    label: "Opened",
  },
  {
    id: "carbs",
    label: "Clicked",
  },
  {
    id: "protein",
    label: "Replied",
  },
  {
    id: "energy",
    label: "Status",
  },
  {
    id: "actions",
    label: "Action",
  },
];

const menuItems = [
  {
    label: "Ongoing",
    value: "ongoing",
    icon: <PlayCircleFilledWhiteOutlinedIcon />,
  },
  { label: "Draft", value: "draft", icon: <BookOutlinedIcon /> },
  {
    label: "Paused",
    value: "paused",
    icon: <PauseCircleOutlineOutlinedIcon />,
  },
  { label: "Pending", value: "pending", icon: <ErrorOutlineOutlinedIcon /> },
  {
    label: "Completed",
    value: "completed",
    icon: <CheckCircleOutlineOutlinedIcon />,
  },
];

const statusArrayObject = {
  Paused: {
    id: 1,
    bgHex: "#fdf2e1",
    colorHex: "#d4ab3d",
    text: "Paused",
  },
  Ongoing: {
    id: 2,
    bgHex: "#d0ddfb",
    colorHex: "#5388d0",
    text: "Ongoing",
  },
  Terminated: {
    id: 3,
    bgHex: "#ffdfbe",
    colorHex: "#b2681b",
    text: "Terminated",
  },
  Completed: {
    id: 4,
    bgHex: "#bde8be",
    colorHex: "#009c35",
    text: "Completed",
  },
  Pending: {
    id: 5,
    bgHex: "#d1dfe9",
    colorHex: "#1c485f",
    text: "Pending",
    extra: "Schedule",
  },
  Schedule: {
    id: 5,
    bgHex: "#d1dfe9",
    colorHex: "#1c485f",
    text: "Schedule",
  },
};

const dropdownItems = [
  // {
  //   name: "Open",
  //   svg: (
  //     <svg
  //       xmlns="http://www.w3.org/2000/svg"
  //       width="20"
  //       height="20"
  //       viewBox="0 0 20 20"
  //       fill="none"
  //     >
  //       <path
  //         d="M18.0583 11.9167L17.725 16.0833C17.6 17.3583 17.5 18.3333 15.2416 18.3333H4.7583C2.49997 18.3333 2.39997 17.3583 2.27497 16.0833L1.94163 11.9167C1.87497 11.225 2.09163 10.5833 2.4833 10.0917C2.49163 10.0833 2.49163 10.0833 2.49997 10.075C2.9583 9.51667 3.64997 9.16667 4.42497 9.16667H15.575C16.35 9.16667 17.0333 9.51667 17.4833 10.0583C17.4916 10.0667 17.5 10.075 17.5 10.0833C17.9083 10.575 18.1333 11.2167 18.0583 11.9167Z"
  //         stroke="#868686"
  //         stroke-width="1.5"
  //         stroke-miterlimit="10"
  //       />
  //       <path
  //         d="M2.9165 9.525V5.23333C2.9165 2.4 3.62484 1.69167 6.45817 1.69167H7.5165C8.57484 1.69167 8.8165 2.00833 9.2165 2.54167L10.2748 3.95833C10.5415 4.30833 10.6998 4.525 11.4082 4.525H13.5332C16.3665 4.525 17.0748 5.23333 17.0748 8.06667V9.55833"
  //         stroke="#868686"
  //         stroke-width="1.5"
  //         stroke-miterlimit="10"
  //         stroke-linecap="round"
  //         stroke-linejoin="round"
  //       />
  //       <path
  //         d="M7.8584 14.1667H12.1417"
  //         stroke="#868686"
  //         stroke-width="1.5"
  //         stroke-miterlimit="10"
  //         stroke-linecap="round"
  //         stroke-linejoin="round"
  //       />
  //     </svg>
  //   ),
  // },
  {
    name: "Delete",
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M17.5 4.98333C14.725 4.70833 11.9333 4.56667 9.15 4.56667C7.5 4.56667 5.85 4.65 4.2 4.81667L2.5 4.98333"
          stroke="#868686"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.0835 4.14167L7.26683 3.05001C7.40016 2.25834 7.50016 1.66667 8.9085 1.66667H11.0918C12.5002 1.66667 12.6085 2.29167 12.7335 3.05834L12.9168 4.14167"
          stroke="#868686"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15.7082 7.61667L15.1665 16.0083C15.0748 17.3167 14.9998 18.3333 12.6748 18.3333H7.32484C4.99984 18.3333 4.92484 17.3167 4.83317 16.0083L4.2915 7.61667"
          stroke="#868686"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.6084 13.75H11.3834"
          stroke="#868686"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.9165 10.4167H12.0832"
          stroke="#868686"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
  },
  {
    name: "Rename",
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M7.9668 15V10.8333"
          stroke="#868686"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.0002 12.9167H5.8335"
          stroke="#868686"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.6665 1.66666V4.16666"
          stroke="#868686"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.3335 1.66666V4.16666"
          stroke="#868686"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.1749 2.85C15.9582 2.95 17.3665 3.975 17.4499 7.89166L17.5582 13.0333C17.6249 16.4667 16.8332 18.1917 12.6665 18.2833L7.66653 18.3833C3.49986 18.4667 2.6332 16.7667 2.56653 13.3417L2.44986 8.19166C2.36653 4.275 3.74153 3.19166 6.5082 2.98333L13.1749 2.85Z"
          stroke="#868686"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
  },
  // {
  //   name: "Duplicate campaign",
  //   svg: (
  //     <svg
  //       xmlns="http://www.w3.org/2000/svg"
  //       width="20"
  //       height="20"
  //       viewBox="0 0 20 20"
  //       fill="none"
  //     >
  //       <path
  //         d="M14.1665 11.1667V13.6667C14.1665 17 12.8332 18.3333 9.49984 18.3333H6.33317C2.99984 18.3333 1.6665 17 1.6665 13.6667V10.5C1.6665 7.16667 2.99984 5.83333 6.33317 5.83333H8.83317"
  //         stroke="#868686"
  //         stroke-width="1.5"
  //         stroke-linecap="round"
  //         stroke-linejoin="round"
  //       />
  //       <path
  //         d="M14.1668 11.1667H11.5002C9.50016 11.1667 8.8335 10.5 8.8335 8.5V5.83333L14.1668 11.1667Z"
  //         stroke="#868686"
  //         stroke-width="1.5"
  //         stroke-linecap="round"
  //         stroke-linejoin="round"
  //       />
  //       <path
  //         d="M9.6665 1.66667H12.9998"
  //         stroke="#868686"
  //         stroke-width="1.5"
  //         stroke-linecap="round"
  //         stroke-linejoin="round"
  //       />
  //       <path
  //         d="M5.8335 4.16667C5.8335 2.78333 6.95016 1.66667 8.3335 1.66667H10.5168"
  //         stroke="#868686"
  //         stroke-width="1.5"
  //         stroke-linecap="round"
  //         stroke-linejoin="round"
  //       />
  //       <path
  //         d="M18.3334 6.66667V11.825C18.3334 13.1167 17.2834 14.1667 15.9917 14.1667"
  //         stroke="#868686"
  //         stroke-width="1.5"
  //         stroke-linecap="round"
  //         stroke-linejoin="round"
  //       />
  //       <path
  //         d="M18.3335 6.66667H15.8335C13.9585 6.66667 13.3335 6.04167 13.3335 4.16667V1.66667L18.3335 6.66667Z"
  //         stroke="#868686"
  //         stroke-width="1.5"
  //         stroke-linecap="round"
  //         stroke-linejoin="round"
  //       />
  //     </svg>
  //   ),
  // },
];

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  borderRadius: 3,
  boxShadow: 24,
  p: 4,
};
const AllCampaigns = () => {
  const userDetails = JSON.parse(localStorage.getItem("MailSenderuserDetails"));
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [isLoading, setIsLoading] = useState(true);
  const history = useHistory();
  const [filterValue, setFilterValue] = useState("");
  const [campaignName, setCampaignName] = useState("");
  const [openCreateCampaignModal, setOpenCreateCampaignModal] = useState(false);
  const [renameStatus, setRenameStatus] = useState(false);
  const [campaigns, setCampaigns] = useState([]);
  const [draft, setDraft] = useState([]);
  const [successType, setSuccessType] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [MenuItemAnchorEl, setMenuItemAnchorEl] = useState(null);
  const openMenuItem = Boolean(MenuItemAnchorEl);
  const [selectedCampaignId, setSelectedCampaignId] = useState("");
  const [alertOpenModal, setAlertOpenModal] = useState(false);
  const [termLoader, setTermLoader] = useState(false);
  const [termSuccess, setTermSuccess] = useState(false);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (option) => () => {
    setSelectedOption(option);
    handleClose();
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - campaigns.length) : 0;

  function formatTimestamp(timestamp) {
    if (campaigns.length > 0) {
      const date = new Date(timestamp);
      const options = {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      };
      const formattedDate = new Intl.DateTimeFormat("en-US", options).format(
        date
      );
      return formattedDate.replace(/,/g, "");
    }
  }

  const handleOnchange = (event) => {
    setFilterValue(event.target.value);
  };

  // -------------- filter campagins based on input value and filter by status value-------------------------------
  const filteredCampaigns = useMemo(() => {
    return campaigns.filter((campaign) => {
      // If no filterValue or selectedOption is provided, display all campaigns
      if (!filterValue && !selectedOption) {
        return true;
      }

      // Check if the campaign's name matches the filterValue (if provided)
      const nameMatchesFilter =
        !filterValue ||
        campaign.campaignDetails.Name.toLowerCase().includes(
          filterValue.toLowerCase()
        );

      // Check if the campaign's status matches the selectedOption (if provided)
      const statusMatchesOption =
        !selectedOption || campaign.campaignDetails.Status === selectedOption;

      // Return true only if both conditions are satisfied
      return nameMatchesFilter && statusMatchesOption;
    });
  }, [campaigns, filterValue, selectedOption]);

  function getAllCampaigns() {
    axios
      .get(
        `${BaseUrl.baseurl}/email-marketing/automation/get-all-user-campaign/${
          userDetails && userDetails.details._id
        }/${page + 1}`,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          console.log(response.data.details);
          setCampaigns(response.data.details);
        } else {
          setCampaigns([]);
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
        setTimeout(() => {
          const campaignDraftedData = JSON.parse(
            localStorage.getItem("draftedcampaigndata")
          );
          if (campaignDraftedData !== null) {
            setDraft(campaignDraftedData);
          }
          setIsLoading(false);
        }, 500);
      })
      .catch((err) => console.log("Error"));
  }
  useEffect(() => {
    getAllCampaigns();
  }, []);
  const [sequenceStatus, setSequenceStatus] = useState(true);
  const handleToggleView = (event) => {
    setSequenceStatus(event.target.checked);
  };
  const createCampaignModalUi = () => {
    return (
      <Modal
        open={openCreateCampaignModal}
        onClose={() => setOpenCreateCampaignModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <p className="modaltext">
            {renameStatus ? "Rename campaign" : "Let's create a new campaign"}
          </p>
          <p className="modalsubtext">What would you like to name it?</p>

          <p className="modalmoxtextlabel" style={{ marginBottom: 2 }}>
            {renameStatus ? "New Name" : "Campaign Name"}
          </p>
          <input
            type="text"
            autoComplete="off"
            value={campaignName}
            onChange={(e) => {
              setCampaignName(e.target.value);
            }}
            placeholder="Ex:My Campaign"
            style={{
              borderRadius: "4px",
              padding: "12px 16px",
              width: "100%",
              outline: "none",
              color: "#868686",
              fontSize: "14px",
              marginTop: 3,
              border: "1px solid #1C485F",
              background: "var(--background-color, #FAFAFA)",
            }}
          />
          {/* {!renameStatus&&(
            <div style={{ display: "flex", alignItems: "center", gap: 5,marginTop:'20px' }}>
            <p
              style={{
                color: !sequenceStatus ? "#1C485F" : "#868686",
                fontSize: "14px",
                fontWeight: 600,
                letterSpacing: "1px",
              }}
            >
              Drip Campaign
            </p>
            <Switch
              checked={sequenceStatus}
              onChange={handleToggleView}
              inputProps={{ "aria-label": "controlled" }}
            />
            <p
              style={{
                color: !sequenceStatus ? "#868686" : "#1C485F",
                fontSize: "14px",
                fontWeight: 600,
                letterSpacing: "1px",
              }}
            >
              Sequence Campaign
            </p>
          </div>
          )} */}

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "32px",
            }}
          >
            <div style={{ alignItems: "center", display: "flex", gap: "10px" }}>
              <div
                className="cancelbuttonmodal"
                onClick={() => {
                  setOpenCreateCampaignModal(false);
                }}
              >
                Cancel
              </div>
              <div
                style={{
                  // opacity:campaignName===""&&0.4,
                  pointerEvents: campaignName === "" && "none",
                }}
                className="continuebuttonmodal"
                onClick={() => {
                  if (renameStatus) {
                    renameCampaignDetails();
                  } else {
                    history.push("/All-Campaign/New-Campaign", {
                      campaignName: campaignName,
                      isEnableSequence: sequenceStatus,
                      from: "new",
                    });
                  }
                }}
              >
                {renameStatus ? "Rename" : "Continue"}
              </div>
            </div>
          </div>
        </Box>
      </Modal>
    );
  };

  function terminateCampaign() {
    let config = {
      method: "put",
      maxBodyLength: Infinity,
      url: `${
        BaseUrl.baseurl
      }/email-marketing/automation/terminate-user-campaign-details/${
        userDetails && userDetails.details._id
      }/${selectedCampaignId._id}`,
      headers: {
        Authorization: `Bearear ${userDetails && userDetails.token}`,
      },
    };

    axios
      .request(config)
      .then((response) => {
        console.log("rres", response);
        if (response.data.status) {
          setTermSuccess(true);
          setTermLoader(false);
          getAllCampaigns();
          toast.success(response.data.message);
        } else {
          toast.error(response.data.message);
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  function renameCampaignDetails() {
    axios
      .put(
        `${BaseUrl.baseurl}/email-marketing/automation/rename-user-campaign/${
          userDetails && userDetails.details._id
        }/${selectedCampaignId._id}`,
        { name: campaignName },
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          setOpenCreateCampaignModal(false);
          toast.success(response.data.message);
          setSuccessType("rename");
          getAllCampaigns();
        } else {
          toast.error(response.data.message);
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => console.log("Error", err));
  }

  function deleteCampaign() {
    axios
      .delete(
        `${BaseUrl.baseurl}/email-marketing/automation/delete-user-campaign/${
          userDetails && userDetails.details._id
        }/${selectedCampaignId._id}`,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          setTermSuccess(false);
          setTermLoader(false);
          setAlertOpenModal(false);
          toast.success(res.data.message);
          setSuccessType("delete");
          getAllCampaigns();
        } else {
          toast.error(res.data.message);
          if (res.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => console.log("Error", err));
  }

  const deleteCampaignModalUi = () => {
    return (
      <Modal
        open={alertOpenModal}
        onClose={() => {
          setAlertOpenModal(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="space-y-3">
            <div className="modaltextdelete">
              {termSuccess ? "Successfully" : "Oops!"}
            </div>
            <div className="modalsubtextfordelete">
              {termSuccess
                ? `“${selectedCampaignId.Name}” Successfully Terminated...`
                : "Oops! It seems you can't delete this campaign directly."}
            </div>
            <div className="modalsublittlepara">
              {termSuccess
                ? "Your campaign has been successfully terminated. You can now click on the 'Delete' button to permanently remove this campaign."
                : "Before you can delete this campaign, please note that you must first terminate it.Would you like to proceed with terminating the campaign now?"}
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
                width: "100%",
                marginTop: "16px",
              }}
            >
              <div
                className="cancelbuttonmodal"
                onClick={() => {
                  setAlertOpenModal(false);
                }}
              >
                Cancel
              </div>
              <div
                className="continuebuttonmodal"
                onClick={() => {
                  setTermLoader(true);
                  if (!termLoader) {
                    if (termSuccess) {
                      deleteCampaign();
                    } else {
                      terminateCampaign();
                    }
                  }
                }}
              >
                {termLoader ? (
                  <CircularProgress
                    size={20}
                    style={{
                      color: "white",
                      marginLeft: termSuccess ? "48px" : "20px",
                      marginRight: termSuccess ? "48px" : "20px",
                    }}
                  />
                ) : (
                  <>{termSuccess ? "Proceed to delete" : "Terminate"}</>
                )}
              </div>
            </div>
          </div>
        </Box>
      </Modal>
    );
  };

  const filterByStatusMenu = () => {
    return (
      <>
        <Button
          id="basic-button"
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
          disableTouchRipple
          disableRipple
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            color: "#1c485f",
            textTransform: "none",
            border: "1px solid #1c485f",
            padding: "7px 12px",
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M6.79992 5.54166H13.1916C13.7249 5.54166 14.1583 5.97499 14.1583 6.50832V7.57499C14.1583 7.96666 13.9166 8.44999 13.6749 8.69166L11.5916 10.5333C11.2999 10.775 11.1083 11.2583 11.1083 11.65V13.7333C11.1083 14.025 10.9166 14.4083 10.6749 14.5583L9.99992 14.9833C9.36658 15.375 8.49992 14.9333 8.49992 14.1583V11.5917C8.49992 11.25 8.30825 10.8167 8.10825 10.575L6.26659 8.63332C6.02492 8.39999 5.83325 7.95832 5.83325 7.66666V6.55832C5.83325 5.97499 6.26659 5.54166 6.79992 5.54166Z"
              stroke="#1C485F"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M7.50008 18.3333H12.5001C16.6667 18.3333 18.3334 16.6667 18.3334 12.5V7.49999C18.3334 3.33332 16.6667 1.66666 12.5001 1.66666H7.50008C3.33341 1.66666 1.66675 3.33332 1.66675 7.49999V12.5C1.66675 16.6667 3.33341 18.3333 7.50008 18.3333Z"
              stroke="#1C485F"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          Filter by status
        </Button>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          {menuItems.map((menuItem) => (
            <MenuItem
              key={menuItem.value}
              onClick={handleMenuItemClick(menuItem.label)}
              sx={{
                padding: "3px 10px",
                display: "flex",
                alignItems: "center",
                gap: "0px",
              }}
            >
              <ListItemIcon>
                <Radio
                  checked={selectedOption === menuItem.label}
                  onChange={handleMenuItemClick(menuItem.label)}
                  color="default"
                  style={{ color: "#1C485F", fontSize: "12px" }}
                />
              </ListItemIcon>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                  paddingRight: 1.5,
                  color: "#868686",
                  fontSize: "13px",
                }}
              >
                {menuItem.icon}
                {menuItem.label}
              </Box>
            </MenuItem>
          ))}
          <MenuItem>
            <button
              onClick={() => {
                setSelectedOption(null);
                handleClose();
              }}
              style={{
                backgroundColor: "#FF3301",
                color: "#FFF",
                padding: "6px 12px",
                borderRadius: 4,
                flexGrow: 1,
                fontSize: "12px",
              }}
            >
              Reset All
            </button>
          </MenuItem>
        </Menu>
      </>
    );
  };

  const handleClickAction = (event, campaignDetails, campaignName) => {
    setMenuItemAnchorEl(event.currentTarget);
    setSelectedCampaignId(campaignDetails);
    setCampaignName(campaignName);
  };

  function createDuplicateCampaign() {
    console.log("seletecte", selectedCampaignId.CampaignCopy);
    let nodes = selectedCampaignId.CampaignCopy.structure;
    let edges = selectedCampaignId.CampaignCopy.edges;
    let campaignCopy = selectedCampaignId.CampaignCopy;
    campaignCopy.name = `${selectedCampaignId.CampaignCopy.name}(Copy)`;
    nodes.map((val) => {
      let top, bottom;
      let bottomArray = [];
      if (val.BackendData !== undefined) {
        edges.map((edge) => {
          if (val.data.label === "Trigger") {
            if (edge.source === val.id) {
              bottomArray.push({
                Edge: edge.target,
                Target: edge.sourceHandle === "a" ? "no" : "yes",
              });
            }
            if (edge.target === val.id) {
              top = edge.source;
            }
          } else {
            if (edge.source === val.id) {
              bottom = edge.target;
            }
            if (edge.target === val.id) {
              top = edge.source;
            }
          }
        });
        val.BackendData.top = top;
        val.BackendData.bottom =
          val.data.label === "Trigger" ? bottomArray : bottom;
      }
    });

    const filteredData =
      selectedCampaignId.CampaignCopy.selectedSchedule.Day.map((val) => {
        if (!val.Active) {
          val.StartHour = 0;
          val.EndHour = 0;
        }
        return val;
      });
    let nodeData = {
      dateFormat: selectedCampaignId.CampaignCopy.selectedSchedule.TimeZone,
      day: filteredData,

      fromEmail: selectedCampaignId.CampaignCopy.fromEmail,
      structure: nodes,
      allContact: selectedCampaignId.CampaignCopy.allContact === "all",
      timeGap: selectedCampaignId.CampaignCopy.timeGap * 60,
      missingVariable:
        selectedCampaignId.CampaignCopy.missingVariable === "check",
      nameListId: selectedCampaignId.CampaignCopy.nameListId._id,
      name: selectedCampaignId.CampaignCopy.name,
      stopOnReply: selectedCampaignId.CampaignCopy.enable,
      campaignCopy: campaignCopy,
      sendOption: {
        Unverified: selectedCampaignId.CampaignCopy.sendOption[0].value,
        Unverifiable: selectedCampaignId.CampaignCopy.sendOption[1].value,
      },
      duration: {
        Status: selectedCampaignId.CampaignCopy.duration.Status,
        CountryDateTime:
          selectedCampaignId.CampaignCopy.duration.CountryDateTime,
        StartDate: selectedCampaignId.CampaignCopy.duration.StartDate,
        EndDate: selectedCampaignId.CampaignCopy.duration.EndDate,
      },
    };
    axios
      .post(
        `${
          BaseUrl.baseurl
        }/email-marketing/automation/create-automation-campaign/${
          userDetails && userDetails.details._id
        }`,
        { data: JSON.stringify(nodeData) },
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((res) => {
        console.log("rres", res);
        if (res.data.status) {
          setSuccessType("duplicate");
          getAllCampaigns();
          toast.success(res.data.message);
        } else {
          toast.error(res.data.message);
          if (res.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => {
        console.log("Error", err);
        toast.error(err.message);
      });
  }

  const handleCloseMenuItem = (option) => () => {
    setMenuItemAnchorEl(null);
    // setSelectedOption(option.name);
    switch (option.name) {
      case "Open":
        history.push("/Statistics", selectedCampaignId);
        break;
      case "Rename":
        setOpenCreateCampaignModal(true);
        setRenameStatus(true);
        break;
      case "Delete":
        console.log("selectedCampaignId", selectedCampaignId.Status);
        console.log("all campaigns", campaigns);
        console.log("filered campaigns", filteredCampaigns);
        // setTermSuccess(false);
        if (selectedCampaignId.Status === "Terminated") {
          setTermSuccess(true);
        }
        setAlertOpenModal(true);
        break;
      case "Duplicate campaign":
        createDuplicateCampaign();
        break;
      default:
        return null;
    }
  };

  function runPendingCampaign(campId) {
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${
        BaseUrl.baseurl
      }/email-marketing/automation/check-run-automation-campaign/${
        userDetails && userDetails.details._id
      }/${campId}`,
      headers: {
        Authorization: `Bearear ${userDetails && userDetails.token}`,
      },
    };

    axios
      .request(config)
      .then((response) => {
        if (response.data.status) {
          toast.success(response.data.message);
          setSuccessType("run");
          getAllCampaigns();
        } else {
          toast.error(response.data.message);
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  const [pauseLoader, setPauseLoader] = useState(false);
  function pauseOngoingCampaign(campId) {
    setPauseLoader(true);
    let config = {
      method: "put",
      maxBodyLength: Infinity,
      url: `${BaseUrl.baseurl}/email-marketing/automation/pause-user-campaign/${
        userDetails && userDetails.details._id
      }/${campId}`,
      headers: {
        Authorization: `Bearear ${userDetails && userDetails.token}`,
      },
    };

    axios
      .request(config)
      .then((response) => {
        if (response.data.status) {
          toast.success(response.data.message);
          setPauseLoader(false);
          setSuccessType("pause");
          getAllCampaigns();
        } else {
          toast.error(response.data.message);
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  function resumePausedCampaign(campId) {
    setPauseLoader(true);
    let config = {
      method: "put",
      maxBodyLength: Infinity,
      url: `${
        BaseUrl.baseurl
      }/email-marketing/automation/resume-user-campaign/${
        userDetails && userDetails.details._id
      }/${campId}`,
      headers: {
        Authorization: `Bearear ${userDetails && userDetails.token}`,
      },
    };

    axios
      .request(config)
      .then((response) => {
        if (response.data.status) {
          toast.success(response.data.message);
          setSuccessType("reusme");
          getAllCampaigns();
          setPauseLoader(false);
        } else {
          toast.error(response.data.message);
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  const draftCampaignTableRowUi = () => {
    return (
      <TableRow>
        <TableCell align="left">
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "2px",
            }}
          >
            <p
              style={{
                marginTop: "0px",
                fontFamily: "Source Sans 3",
                fontSize: "15px",
                fontStyle: "normal",
                fontWeight: 700,
                color: "#868686",
              }}
            >
              {draft.name}
            </p>
            <p
              style={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
                marginTop: "0px",
              }}
            >
              <span
                style={{
                  fontFamily: "Source Sans 3",
                  fontSize: "12px",
                  fontStyle: "normal",
                  fontWeight: 400,
                  color: "#868686",
                }}
              >
                {formatTimestamp(draft.createdDate)}
              </span>
            </p>
          </Box>
        </TableCell>
        <TableCell align="left" sx={{ color: "#868686" }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 25 24"
              fill="none"
            >
              <path
                d="M21.2468 17.8385L19.6168 18.3885C19.1668 18.5385 18.8068 18.8885 18.6568 19.3485L18.1068 20.9785C17.6368 22.3885 15.6568 22.3585 15.2168 20.9485L13.3668 14.9985C13.0068 13.8185 14.0968 12.7185 15.2668 13.0885L21.2268 14.9385C22.6268 15.3785 22.6468 17.3685 21.2468 17.8385Z"
                stroke="#868686"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M22.2852 12C22.2852 6.48 17.8052 2 12.2852 2C6.76516 2 2.28516 6.48 2.28516 12C2.28516 17.52 6.76516 22 12.2852 22"
                stroke="#868686"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            {/* {row.totalSentEmail} */}
            <p>0</p>
          </Box>
        </TableCell>
        <TableCell align="left" sx={{ color: "#868686" }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 25 24"
              fill="none"
            >
              <path
                d="M7.57031 12C3.57031 12 3.57031 13.79 3.57031 16V17C3.57031 19.76 3.57031 22 8.57031 22H16.5703C20.5703 22 21.5703 19.76 21.5703 17V16C21.5703 13.79 21.5703 12 17.5703 12C16.5703 12 16.2903 12.21 15.7703 12.6L14.7503 13.68C13.5703 14.94 11.5703 14.94 10.3803 13.68L9.37031 12.6C8.85031 12.21 8.57031 12 7.57031 12Z"
                stroke="#868686"
                stroke-width="1.5"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M19.5703 12V6C19.5703 3.79 19.5703 2 15.5703 2H9.57031C5.57031 2 5.57031 3.79 5.57031 6V12"
                stroke="#868686"
                stroke-width="1.5"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            {/* {row.totalEmailOpened} */}
            <p>0</p>
          </Box>
        </TableCell>
        <TableCell align="left" sx={{ color: "#868686" }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 25 24"
              fill="none"
            >
              <path
                d="M12.857 14.8794C11.947 14.8794 11.207 14.1394 11.207 13.2294V10.7594C11.207 9.8494 11.947 9.10938 12.857 9.10938C13.767 9.10938 14.507 9.8494 14.507 10.7594V13.2294C14.507 14.1394 13.767 14.8794 12.857 14.8794Z"
                stroke="#868686"
                stroke-width="1.5"
                stroke-linecap="round"
              />
              <path
                d="M17.8355 13.4697C17.6355 16.0497 15.4755 18.0697 12.8555 18.0697C10.0955 18.0697 7.85547 15.8297 7.85547 13.0697V10.9297C7.85547 8.16969 10.0955 5.92969 12.8555 5.92969C15.4455 5.92969 17.5755 7.89968 17.8255 10.4197"
                stroke="#868686"
                stroke-width="1.5"
                stroke-linecap="round"
              />
              <path
                d="M15.8555 2H17.8555C20.8555 2 22.8555 4 22.8555 7V9"
                stroke="#868686"
                stroke-width="1.5"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M2.85547 9V7C2.85547 4 4.85547 2 7.85547 2H9.85547"
                stroke="#868686"
                stroke-width="1.5"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M15.8555 22H17.8555C20.8555 22 22.8555 20 22.8555 17V15"
                stroke="#868686"
                stroke-width="1.5"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M2.85547 15V17C2.85547 20 4.85547 22 7.85547 22H9.85547"
                stroke="#868686"
                stroke-width="1.5"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            {/* {row.totalEmailClicked} */}
            <span>0 </span>
          </Box>
        </TableCell>
        <TableCell align="left" sx={{ color: "#868686" }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 25 24"
              fill="none"
            >
              <path
                d="M10.4523 13.6914L15.2984 8.84522M20.2558 5.8877L16.1652 19.1823C15.7986 20.3737 15.6152 20.9697 15.299 21.1673C15.0247 21.3386 14.6852 21.3673 14.3865 21.2433C14.0421 21.1004 13.7625 20.5423 13.2049 19.427L10.6139 14.2451C10.5254 14.0681 10.4811 13.98 10.422 13.9033C10.3696 13.8353 10.309 13.774 10.241 13.7215C10.166 13.6637 10.0794 13.6204 9.9103 13.5359L4.71645 10.939C3.60115 10.3813 3.04345 10.1022 2.90054 9.75781C2.7766 9.45912 2.80486 9.11925 2.97622 8.845C3.17381 8.52876 3.76976 8.34505 4.96157 7.97834L18.2562 3.8877C19.1931 3.5994 19.6618 3.45537 19.9783 3.57155C20.2539 3.67275 20.4712 3.88986 20.5724 4.16553C20.6886 4.48185 20.5444 4.95029 20.2564 5.88631L20.2558 5.8877Z"
                stroke="#868686"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            {/* {row.totalCampaignReplied} */}
            <span>0 </span>
          </Box>
        </TableCell>
        <TableCell align="left" sx={{ color: "#868686" }}>
          <Box
            sx={{
              backgroundColor: "#ddd",
              color: "#5e5e5e",
              borderRadius: "25px",
              textAlign: "center",
              padding: "10px 0px",
              fontWeight: 700,
            }}
          >
            Draft
          </Box>
        </TableCell>
        <TableCell align="left">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <button
              style={{
                pointerEvents: "none",
                opacity: 0.3,
                zIndex: 1,
                color: "#868686",
              }}
            >
              <PlayCircleOutlineRoundedIcon />
            </button>

            <button
              onClick={() => {
                history.push("/All-Campaign/New-Campaign", {
                  campaignName: draft.name,
                  from: "draft",
                  isEnableSequence: draft.sequence,
                });
              }}
              style={{
                color: "#868686",
              }}
            >
              <ModeEditRoundedIcon />
            </button>
            <button></button>
            <button
              style={{
                color: "#868686",
              }}
              onClick={() => setOpenDeleteDraftModal(true)}
            >
              <DeleteIcon />
            </button>
          </div>
        </TableCell>
      </TableRow>
    );
  };

  const [openDeleteDraftModal, setOpenDeleteDraftModal] = useState(false);
  const deleteDraftCampaignModalUi = () => {
    return (
      <Modal
        open={openDeleteDraftModal}
        onClose={() => {
          setOpenDeleteDraftModal(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="modalPopupDelete">
          <div className="modaltextdelete">Oops!</div>
          <div className="modalsubtextfordelete">
            Oops! are you sure want to delete the draft.
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
              width: "100%",
              marginTop: "16px",
            }}
          >
            <div
              className="cancelbuttonmodal"
              onClick={() => {
                setOpenDeleteDraftModal(false);
              }}
            >
              Cancel
            </div>
            <div
              className="continuebuttonmodal"
              onClick={() => {
                setOpenDeleteDraftModal(false);
                setDraft([]);
                localStorage.removeItem("draftedcampaigndata");
              }}
            >
              Proceed to delete
            </div>
          </div>
        </div>
      </Modal>
    );
  };
  const recipients2 = [
    { email: "user1@example.com", name: "User 1" },
    { email: "user2@example.com", name: "User 2" },
    { email: "user3@example.com", name: "User 3" },
    { email: "user4@example.com", name: "User 4" },
    { email: "user5@example.com", name: "User 5" },
    { email: "user6@example.com", name: "User 6" },
  ];
  const senders2 = [
    "sender1@example.com",
    "sender2@example.com",
    "sender3@example.com",
  ];
  function distributeRecipients(senders, recipients) {
    const output = senders.map((sender) => ({ sender, recipient: [] }));
    recipients.forEach((recipient, index) => {
      output[index % senders.length].recipient.push(recipient);
    });
    return output;
  }
  useEffect(() => {
    console.log("new array", distributeRecipients(senders2, recipients2));
  }, []);
  return (
    <div
      style={{
        height: "100%",
        overflow: "auto",
        // backgroundColor: "#FFF",
        borderRadius: "5px",
      }}
    >
      <Box sx={{ width: "100%" }}>
        <Paper
          sx={{
            width: "100%",
            borderRadius: "6px",
            border: "1px solid #DDD",
            boxShadow: "none",
          }}
        >
          <Box
            sx={{
              borderBottom: "1px solid #DDD",
              padding: "10px 16px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Button
              disableRipple
              disableElevation
              sx={{
                cursor: "default",
                outline: "none !important",
                borderBottom: "2px solid #1C485F",
                borderRadius: 0,
                color: "#1C485F",
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "transparent",
                },
              }}
            >
              <Typography
                style={{
                  color: "#1C485F",
                  fontSize: "15px",
                  fontWeight: 700,
                  fontFamily: "Source Sans 3",
                }}
                component="h2"
              >
                All Campaigns
              </Typography>
            </Button>
            {/* table header action buttons */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                  backgroundColor: "#FAFAFA",
                  padding: "9px 12px",
                  borderRadius: "4px",
                  border: "1px solid #1c485f",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M7.66536 13.9987C11.1632 13.9987 13.9987 11.1632 13.9987 7.66536C13.9987 4.16756 11.1632 1.33203 7.66536 1.33203C4.16756 1.33203 1.33203 4.16756 1.33203 7.66536C1.33203 11.1632 4.16756 13.9987 7.66536 13.9987Z"
                    stroke="#868686"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M14.6654 14.6654L13.332 13.332"
                    stroke="#868686"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <input
                  value={filterValue}
                  onChange={handleOnchange}
                  type="text"
                  style={{
                    outline: "none",
                    backgroundColor: "transparent",
                    padding: "0px 12px",
                  }}
                  placeholder="Search.."
                />
              </Box>
              <button
                className="addemailaccountbutton"
                style={{ padding: "7px 12px" }}
                onClick={() => {
                  history.push("/Email/accounts", "Email Accounts");
                }}
              >
                <AddBoxOutlinedIcon />
                Add new email account
              </button>
              {filterByStatusMenu()}
              <button
                className="schedule-button"
                onClick={() => {
                  history.push("/All-Campaign/Schedule");
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M10 6.66666V10.8333"
                    stroke="#1C485F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9.99992 18.3333C5.97492 18.3333 2.70825 15.0667 2.70825 11.0417C2.70825 7.01667 5.97492 3.75 9.99992 3.75C14.0249 3.75 17.2916 7.01667 17.2916 11.0417"
                    stroke="#1C485F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M7.5 1.66666H12.5"
                    stroke="#1C485F"
                    stroke-width="1.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12.4167 15.4167V14.45C12.4167 13.2583 13.2667 12.7667 14.3001 13.3667L15.1334 13.85L15.9667 14.3333C17.0001 14.9333 17.0001 15.9083 15.9667 16.5083L15.1334 16.9917L14.3001 17.475C13.2667 18.075 12.4167 17.5833 12.4167 16.3917V15.4167Z"
                    stroke="#1C485F"
                    stroke-width="1.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                Schedule
              </button>
              <button
                onClick={() => {
                  setOpenCreateCampaignModal(true);
                  setCampaignName("");
                  setRenameStatus(false);
                }}
                className="createCampaignfilledbutton"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <g clip-path="url(#clip0_2010_4013)">
                    <path
                      d="M8 16H5.43C3.14 16 2 14.86 2 12.57V5.43C2 3.14 3.14 2 5.43 2H10C12.29 2 13.43 3.14 13.43 5.43"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M18.5701 22H14.0001C11.7101 22 10.5701 20.86 10.5701 18.57V11.43C10.5701 9.14 11.7101 8 14.0001 8H18.5701C20.8601 8 22.0001 9.14 22.0001 11.43V18.57C22.0001 20.86 20.8601 22 18.5701 22Z"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M14.8701 15H18.1301"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M16.5 16.63V13.37"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_2010_4013">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                Create Campaign
              </button>
            </Box>
          </Box>
          <TableContainer>
            <Table
              sx={{ minWidth: 750 }}
              aria-labelledby="tableTitle"
              size={"medium"}
            >
              {isLoading ? (
                // this body for display loading
                <TableBody>
                  <TableRow>
                    <TableCell
                      colSpan={headCells.length}
                      align="center"
                      sx={{ borderBottom: "0px" }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: "8px",
                          padding: "130px 0px",
                        }}
                      >
                        <Loader />
                      </Box>
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : filteredCampaigns.length > 0 || draft.length !== 0 ? (
                <>
                  <TableHead>
                    <TableRow
                      sx={{ backgroundColor: "#FAFAFA", borderRadius: "4px" }}
                    >
                      {headCells.map((headCell, index) => (
                        <TableCell
                          key={headCell.id}
                          align={index === 5 || index === 6 ? "center" : "left"}
                        >
                          <Typography
                            variant="subtitle1"
                            fontWeight="bold"
                            fontSize={"13px"}
                          >
                            {headCell.label}
                          </Typography>
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  {/* // this body is for displaying table data */}
                  <TableBody>
                    {draft.length !== 0 && draftCampaignTableRowUi()}
                    {filteredCampaigns
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row, index) => (
                        <TableRow
                          key={row.id}
                          sx={{
                            backgroundColor:
                              draft.length !== 0
                                ? index % 2 === 0
                                  ? "#FAFAFA"
                                  : "#FFF"
                                : index % 2 === 0
                                ? "#FFF"
                                : "#FAFAFA",
                            marginBottom: "8px",
                          }}
                        >
                          <TableCell align="left">
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "2px",
                              }}
                            >
                              <p
                                style={{
                                  marginTop: "0px",
                                  fontFamily: "Source Sans 3",
                                  fontSize: "15px",
                                  fontStyle: "normal",
                                  fontWeight: 700,
                                  color: "#1c485f",
                                }}
                              >
                                {row.campaignDetails.Name}
                              </p>
                              <p
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "4px",
                                  marginTop: "0px",
                                }}
                              >
                                <span
                                  style={{
                                    fontFamily: "Source Sans 3",
                                    fontSize: "12px",
                                    fontStyle: "normal",
                                    fontWeight: 400,
                                    color: "#868686",
                                  }}
                                >
                                  {formatTimestamp(
                                    row.campaignDetails.createdAt
                                  )}
                                </span>
                              </p>
                            </Box>
                          </TableCell>
                          <TableCell align="left" sx={{ color: "#868686" }}>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                              }}
                            >
                              <CampaignSentSvgIcon />
                              {row.totalSentEmail}
                            </Box>
                          </TableCell>
                          <TableCell align="left" sx={{ color: "#868686" }}>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                              }}
                            >
                              <CampaignOpenedSvgIcon />
                              {row.totalEmailOpened}
                            </Box>
                          </TableCell>
                          <TableCell align="left" sx={{ color: "#868686" }}>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                              }}
                            >
                              <CampaignClickedSvgIcon />
                              {row.totalEmailClicked}
                            </Box>
                          </TableCell>
                          <TableCell align="left" sx={{ color: "#868686" }}>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                              }}
                            >
                              <CampaignRepliedSvgIcon />
                              {row.totalCampaignReplied}
                            </Box>
                          </TableCell>
                          <TableCell align="left" sx={{ color: "#868686" }}>
                            <Box
                              sx={{
                                backgroundColor:
                                  statusArrayObject[row.campaignDetails.Status]
                                    ?.bgHex,
                                color:
                                  statusArrayObject[row.campaignDetails.Status]
                                    ?.colorHex,
                                borderRadius: "25px",
                                textAlign: "center",
                                padding: "10px 0px",
                                fontWeight: 700,
                              }}
                            >
                              {
                                statusArrayObject[row.campaignDetails.Status]
                                  ?.text
                              }
                            </Box>
                          </TableCell>
                          <TableCell align="left">
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                              }}
                            >
                              {pauseLoader &&
                              selectedCampaignId._id ===
                                row.campaignDetails._id ? (
                                <CircularProgress
                                  size={20}
                                  sx={{ color: "#1C485F", fontSize: 24 }}
                                />
                              ) : (
                                <button
                                  style={{
                                    pointerEvents:
                                      (row.campaignDetails.Status ===
                                        "Terminated" ||
                                        row.campaignDetails.Status ===
                                          "Completed" ||
                                        row.campaignDetails.Status ===
                                          "Schedule") &&
                                      "none",
                                    opacity:
                                      (row.campaignDetails.Status ===
                                        "Terminated" ||
                                        row.campaignDetails.Status ===
                                          "Completed" ||
                                        row.campaignDetails.Status ===
                                          "Schedule") &&
                                      0.3,
                                    color: "#868686",
                                  }}
                                  onClick={() => {
                                    if (
                                      row.campaignDetails.Status === "Ongoing"
                                    ) {
                                      setSelectedCampaignId(
                                        row.campaignDetails
                                      );
                                      pauseOngoingCampaign(
                                        row.campaignDetails._id
                                      );
                                    } else {
                                      setSelectedCampaignId(
                                        row.campaignDetails
                                      );
                                      if (
                                        row.campaignDetails.Status === "Paused"
                                      ) {
                                        resumePausedCampaign(
                                          row.campaignDetails._id
                                        );
                                      } else {
                                        runPendingCampaign(
                                          row.campaignDetails._id
                                        );
                                      }
                                    }
                                  }}
                                >
                                  {row.campaignDetails.Status === "Ongoing" ? (
                                    <Tooltip title="Pause" arrow>
                                      <PauseCircleOutlineOutlinedIcon />
                                    </Tooltip>
                                  ) : (
                                    <Tooltip title="Resume" arrow>
                                      <PlayCircleOutlineRoundedIcon />
                                    </Tooltip>
                                  )}
                                </button>
                              )}
                              <button
                                style={{
                                  pointerEvents:
                                    (row.campaignDetails.Status ===
                                      "Schedule" ||
                                      row.campaignDetails.Status ===
                                        "Completed") &&
                                    "none",
                                  opacity:
                                    (row.campaignDetails.Status ===
                                      "Schedule" ||
                                      row.campaignDetails.Status ===
                                        "Completed") &&
                                    "0.4",
                                  color: "#868686",
                                }}
                                onClick={() => {
                                  history.push("/All-Campaign/New-Campaign", {
                                    campaignName: row.campaignDetails.Name,
                                    campaignId: row.campaignDetails._id,
                                    from: "edit",
                                    isEnableSequence:
                                      row.campaignDetails.CampaignCopy.sequence,
                                    campaignData:
                                      row.campaignDetails.CampaignCopy,
                                  });
                                }}
                              >
                                <Tooltip title="Edit campaign" arrow>
                                  <ModeEditRoundedIcon />
                                </Tooltip>
                              </button>
                              <button
                                style={{ color: "#868686" }}
                                onClick={() => {
                                  history.push(
                                    "/Statistics",
                                    row.campaignDetails
                                  );
                                }}
                              >
                                <Tooltip
                                  title="Open campaign"
                                  arrow
                                  placement="auto"
                                >
                                  <VisibilityIcon />
                                </Tooltip>
                              </button>
                              <div>
                                <IconButton
                                  aria-label="more"
                                  id="long-button"
                                  aria-controls={
                                    openMenuItem ? "long-menu" : undefined
                                  }
                                  aria-expanded={
                                    openMenuItem ? "true" : undefined
                                  }
                                  aria-haspopup="true"
                                  onClick={(event) =>
                                    handleClickAction(
                                      event,
                                      row.campaignDetails,
                                      row.campaignDetails.Name
                                    )
                                  }
                                  disableRipple
                                  disableTouchRipple
                                  disableFocusRipple
                                  style={{ outline: "none", padding: "0px" }}
                                >
                                  <MoreVertIcon />
                                </IconButton>
                                <Menu
                                  id="long-menu"
                                  MenuListProps={{
                                    "aria-labelledby": "long-button",
                                  }}
                                  anchorEl={MenuItemAnchorEl}
                                  open={openMenuItem}
                                  onClose={() => {
                                    setMenuItemAnchorEl(null);
                                    setSelectedOption(null);
                                  }}
                                  PaperProps={{
                                    elevation: 0,
                                    style: {
                                      boxShadow:
                                        "rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px",
                                    },
                                  }}
                                >
                                  {dropdownItems.map((option, index) => (
                                    <MenuItem
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "12px",
                                        fontFamily: "Source Sans 3",
                                        fontSize: "14px",
                                        fontStyle: "normal",
                                        fontWeight: 400,
                                        color: "#4B4B4B",
                                      }}
                                      key={index}
                                      selected={option.name === selectedOption}
                                      onClick={handleCloseMenuItem(option)}
                                    >
                                      <Tooltip
                                        title={`${option.name} campaign`}
                                        arrow
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "10px",
                                        }}
                                      >
                                        {option.svg}
                                        {option.name}
                                      </Tooltip>
                                    </MenuItem>
                                  ))}
                                </Menu>
                              </div>
                            </div>
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </>
              ) : (
                // this body for displaying empty data
                <TableBody>
                  <TableRow>
                    <TableCell
                      colSpan={headCells.length}
                      align="center"
                      sx={{ borderBottom: "0px" }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <img
                          src={noCampaignImage}
                          alt="Nothing found"
                          style={{ height: "250px" }}
                        />
                        <p
                          style={{
                            fontFamily: "Source Sans 3",
                            fontSize: "20px",
                            fontStyle: "normal",
                            fontWeight: 700,
                            color: "#393939",
                          }}
                        >
                          No data found
                        </p>
                        <p
                          style={{
                            fontFamily: "Source Sans 3",
                            fontSize: "14px",
                            fontStyle: "normal",
                            fontWeight: 400,
                            color: "#868686",
                            marginTop: "0px",
                          }}
                        >
                          {filterValue.length === 0
                            ? "Oops! You don’t have any campaigns yet!"
                            : `There's no campaign that fits your search`}
                        </p>
                        <button
                          onClick={() => {
                            setOpenCreateCampaignModal(true);
                            setCampaignName("");
                            setRenameStatus(false);
                          }}
                          className="createCampaignfilledbutton"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <g clip-path="url(#clip0_2010_4013)">
                              <path
                                d="M8 16H5.43C3.14 16 2 14.86 2 12.57V5.43C2 3.14 3.14 2 5.43 2H10C12.29 2 13.43 3.14 13.43 5.43"
                                stroke="white"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M18.5701 22H14.0001C11.7101 22 10.5701 20.86 10.5701 18.57V11.43C10.5701 9.14 11.7101 8 14.0001 8H18.5701C20.8601 8 22.0001 9.14 22.0001 11.43V18.57C22.0001 20.86 20.8601 22 18.5701 22Z"
                                stroke="white"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M14.8701 15H18.1301"
                                stroke="white"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M16.5 16.63V13.37"
                                stroke="white"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_2010_4013">
                                <rect width="24" height="24" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                          Create Campaign
                        </button>
                      </Box>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
              {emptyRows > 0 && (
                <TableRow
                  style={{
                    height: 53 * emptyRows,
                  }}
                >
                  <TableCell colSpan={7} />
                </TableRow>
              )}
            </Table>
          </TableContainer>
          {isLoading
            ? null
            : filteredCampaigns.length > 0 && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                  }}
                >
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={campaigns.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </div>
              )}
        </Paper>
      </Box>
      <ToastContainer />
      {openCreateCampaignModal && createCampaignModalUi()}
      {alertOpenModal && deleteCampaignModalUi()}
      {openDeleteDraftModal && deleteDraftCampaignModalUi()}
    </div>
  );
};
export default AllCampaigns;
